const parseResponse = async (response) => {
  let data = null

  try {
    data = await response.json()
  } catch {
    data = null
  }

  if (!response.ok) {
    throw new Error(data?.error || 'Request failed')
  }

  return data
}

export const fetchResourceDetails = async ({ resourceType, resourceId }) => {
  const qs = new URLSearchParams({
    resource_type: resourceType,
    resource_id: resourceId
  })

  const response = await fetch(`/api/resource_details?${qs}`, {
    method: 'GET',
    headers: { Accept: 'application/json' },
    credentials: 'same-origin'
  })

  return parseResponse(response)
}
